/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculators and helpers for students and teachers.`)
};

const es_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras y ayudas para estudiantes y profesores.`)
};

const de_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner und Helfer für Schüler und Lehrer.`)
};

const nl_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekenmachines en hulpmiddelen voor studenten en docenten.`)
};

const fr_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateurs et outils d'aide pour élèves et enseignants.`)
};

const it_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori e strumenti per studenti e insegnanti.`)
};

const pt_br2_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras e ferramentas de apoio para alunos e professores.`)
};

const pt_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras e apoios para estudantes e professores.`)
};

const ja_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学生・教師向けの計算・補助ツール。`)
};

const zh_cat_education_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为学生和教师准备的计算器和辅助工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_education_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_education_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_education_desc", locale)
	if (locale === "en") return en_cat_education_desc(inputs)
	if (locale === "es") return es_cat_education_desc(inputs)
	if (locale === "de") return de_cat_education_desc(inputs)
	if (locale === "nl") return nl_cat_education_desc(inputs)
	if (locale === "fr") return fr_cat_education_desc(inputs)
	if (locale === "it") return it_cat_education_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_education_desc(inputs)
	if (locale === "pt") return pt_cat_education_desc(inputs)
	if (locale === "ja") return ja_cat_education_desc(inputs)
	return zh_cat_education_desc(inputs)
};